import BaseHttp from './baseHttp'

export default class CommonCodeApi extends BaseHttp {
  constructor() {
    super()
    this.baseUrl = 'commoncodes'
  }

  getCategory(category) {
    this.childPath = category
    return this.get()
  }
}
